import React from 'react'
import AuthorInfoCard from './AuthorInfoCard'

import styles from './BuyCards.module.css'

const StoryCard = ({ story }) => {
  return <div className={styles['story-card']}>
    <div className={styles.title}>卡片故事</div>
    {JSON.stringify(story.author) !== '{}' && <AuthorInfoCard story={story} />}
    <div className={styles.story}>
      <div className={styles.title}>{story.name}</div>
      <div className={styles.content}>{story.story}</div>
    </div>
  </div>
}

export default StoryCard